// @ts-nocheck
import * as React from "react";
import { G, Mask, Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

export const FacebookColoured = (props: IIconProps) => {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      {/* // ts-ignore */}
      <Mask
        id="mask0_1179_7765"
        style={{
          maskType: "alpha",
        }}
        maskUnits={"userSpaceOnUse"}
        x="2"
        y="2"
        width="21"
        height="21"
      >
        <Path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.00183 2.00122H22.0018V22.0024H2.00183V2.00122Z"
          fill="white"
        />
      </Mask>
      <G mask="url(#mask0_1179_7765)">
        <Path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M22 12.0611C22 6.50451 17.5229 2 12 2C6.47715 2 2 6.50451 2 12.0611C2 17.0829 5.65686 21.2452 10.4375 22V14.9694H7.89844V12.0611H10.4375V9.84452C10.4375 7.32296 11.9304 5.93012 14.2146 5.93012C15.3087 5.93012 16.4531 6.12663 16.4531 6.12663V8.60261H15.1921C13.9499 8.60261 13.5625 9.37816 13.5625 10.1738V12.0611H16.3359L15.8926 14.9694H13.5625V22C18.3431 21.2452 22 17.0829 22 12.0611Z"
          fill="#1877F2"
        />
      </G>
    </Icon>
  );
};

export default FacebookColoured;
